export default __webpack_public_path__ + "images/bb8ef82bc92a84a9a4ad5fa0461f82e1-facesign-logo.svg";